import { Action, ThunkAction } from '@reduxjs/toolkit';
import type { AxiosRequestConfig, AxiosResponse } from 'axios';
import { setLoading } from '../redux/commonReducer';
import { AppState } from '../redux/store';
import { apiClient } from '../api/apiClient';
import { mappedParamsRequest } from './utils';

function fetchThunk<T = any, D = any>(
  options: AxiosRequestConfig<D>,
  isRaw = false,
  loading = true
): ThunkAction<Promise<AxiosResponse<T, D>>, AppState, null, Action> {
  return async (dispatch) => {
    if (loading) dispatch(setLoading(true));
    try {
      const requestConfig: AxiosRequestConfig<D> = {
        ...options,
        data: (isRaw
          ? options.data
          : ['post', 'put'].includes(options.method || '') && !Array.isArray(options.data)
            ? mappedParamsRequest(options.data)
            : options.data) as D | undefined,
      };
      if (!requestConfig.url) throw '';
      const json = await apiClient().axios.request<T>(requestConfig);
      return json || ({} as AxiosResponse<T, D>);
    } finally {
      if (loading) dispatch(setLoading(false));
    }
  };
}

export default fetchThunk;
